export const emailRegex = /^[a-zA-Z0-9](\.?[a-zA-Z0-9+!_-]){0,}@[a-zA-Z0-9-]+\.([a-zA-Z]{1,6}\.)?[a-zA-Z]{2,6}$/
